// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uHbV","input":"styles_input__cZO9t"};